import request from '../helpers/request';

const addCalendarEvent = async (data) => {
  return await request.post(
    `/Request/add_task`,
    data,
    'Не удалось добавить событие в календарь'
  );
};

export default addCalendarEvent;
